export const clientQuotes = [
    {
        brand: 'Theo',
        quote: '"Our results and online presence went through the roof more or less overnight, mind-blowing!"',
        name: 'Malik Shkraba',
        role: 'COO of Friday',
        image: '/images/client-media-1.jpg',
        alt: 'Luxury perfume bottles arranged on a marble surface'
    },
    {
        brand: 'Amsterdam',
        quote: '"These guy don’t mess around. we saw results from month one. If you want to grow your business, look no further."',
        name: 'Tony Gomez',
        role: 'Founder of Thursday',
        image: '/images/client-media-2.jpg',
        alt: 'Pastel canal houses lining an Amsterdam waterway'
    },
    {
        brand: 'Savannah',
        quote: '"Funnel absolutely blew the previous agency we were working with out of the water."',
        name: 'Naomi Campbell',
        role: 'CEO of Wednesday',
        image: '/images/client-media-3.jpg',
        alt: 'A bright bedroom with crisp white linen and large windows'
    },
    {
        brand: 'Aura',
        quote: '"From where we were before Funnel to where we are now; it’s absolutely apart."',
        name: 'Charlotte Johansen',
        role: 'Founder of Tuesday',
        image: '/images/client-media-4.jpg',
        alt: 'A minimal cosmetic bottle on a textured stone surface'
    }
]

export const results = [
    {
        name: 'Nostalgie',
        headline: '47% increase in new customers.',
        image: '/images/result-nostalgie.png',
        badges: ['65% Increase in CTR', '37% Reduction in CPA']
    },
    {
        name: 'Classicé',
        headline: '34% increase in online sales.',
        image: '/images/result-classice.png',
        badges: ['57% Increase in CTR', '69% Reduction in CPR']
    },
    {
        name: 'Yogamy',
        headline: 'From $0 to $1,000,000 in sales.',
        image: '/images/result-yogamy.png',
        badges: ['85% Increase in CTR', '36% Reduction in CPR']
    }
]

export const serviceCards = [
    {
        title: 'Meta Ads',
        body: 'Our team has decades of combined experience creating winning Facebook & Instagram campaigns.'
    },
    {
        title: 'Google Ads',
        body: 'Put your products in front of active buyers and beat out the competition with expert Google Shopping services.'
    },
    {
        title: 'TikTok Ads',
        body: 'With over 800 million monthly users in the US, TikTok is the strongest link between your brand and the next generation.'
    }
]

export const comparison = {
    others: [
        'Slow communication',
        'Single channel approach',
        'Outdated growth strategies',
        'Lack of industry research',
        'Outsourced to mediocre talent'
    ],
    ours: [
        'Constant, proactive communication',
        'Omni-channel approach',
        'Tailored best-fit solutions',
        'Provides industry specific expertise',
        'Experts with 10+ years of experience'
    ]
}

export const processSteps = [
    {
        title: 'Funnel Audit',
        body: 'We’ll start by analyzing your sales funnel and seeing what’s holding you back.'
    },
    {
        title: 'Campaign Setup',
        body: 'Then, with your business goals in mind, we will set up the advertising campaigns.'
    },
    {
        title: 'Maximize Profit',
        body: 'We’ll then work towards driving the cost per action down to maximize profit.'
    }
]

export const testimonials = [
    {
        quote: '"Funnel transformed our business overnight. From stale oragnic growth to explosive growth with Google Ads and it’s scaling everyday."',
        name: 'Jonathan Day',
        role: 'Co-founder of Monday',
        image: '/images/client-1.jpg'
    },
    {
        quote: '"We never realised the power of paid advertising until we found Funnel. It’s doubled our revenue in just a few months, absolutely incredible."',
        name: 'Melissa Reid',
        role: 'Founder of Tuesday',
        image: '/images/client-2.jpg'
    },
    {
        quote: '"Funnel turned our marketing game around! With their paid advertising strategies, we saw a remarkable boost in sales that we never thought possible."',
        name: 'Chris Wright',
        role: 'CEO of Wednesday',
        image: '/images/client-3.jpg'
    },
    {
        quote: '"Before discovering Funnel, we were hesitant about investing in paid advertising, but the team proved us wrong with their incredible results."',
        name: 'Terri Williams',
        role: 'Founder of Thursday',
        image: '/images/client-4.jpg'
    },
    {
        quote: '"Funnel exceeded our expectations! Their approach to paid advertising is unparalleled, resulting in a substantial growth in our revenue stream."',
        name: 'Belinda Meyers',
        role: 'COO of Friday',
        image: '/images/client-5.jpg'
    },
    {
        quote: '"Thanks to Funnel, our business experienced a remarkable turnaround. Their expertise in paid advertising tripled our revenuein record time."',
        name: 'Sarah Yanna',
        role: 'Director of Saturday',
        image: '/images/client-6.jpg'
    }
]

export const team = [
    {
        name: 'James Dunn',
        role: 'Founder of Funnel',
        image: '/images/team-james.png'
    },
    {
        name: 'Ayesha Dune',
        role: 'Head of Sales',
        image: '/images/team-ayesha.png'
    },
    {
        name: 'Joshua Brown',
        role: 'Social Media Executive',
        image: '/images/team-joshua.png'
    },
    {
        name: 'Crystal Lane',
        role: 'Head of Marketing',
        image: '/images/team-crystal.png'
    }
]

export const faqs = [
    {
        question: 'How do you tailor Google Ads strategies for different businesses?',
        answer: 'Every account starts with a deep audit of your funnel, your margins and your search demand. From there we build keyword clusters around commercial intent, write ad copy that matches each stage of that intent, and set bidding strategies to the outcome you actually care about, whether that is leads, revenue or return on ad spend.'
    },
    {
        question: 'What’s unique about your Meta Ads approach?',
        answer: 'We treat creative as the primary lever. Instead of endlessly reshuffling audiences, we ship a steady pipeline of new angles, hooks and formats, then let the algorithm find the buyers. Winning concepts are iterated weekly so performance compounds instead of decaying.'
    },
    {
        question: 'How do you ensure effective TikTok Ads targeting and engagement?',
        answer: 'TikTok rewards native content, so we build ads that look and feel like the feed. We pair broad targeting with trend-driven creative, test hooks in the first three seconds, and use engagement signals to feed the algorithm the right audience rather than forcing it.'
    },
    {
        question: 'How do you choose ad formats and placements across platforms?',
        answer: 'Format follows the objective. Awareness leans on video and Reels placements, consideration uses carousels and collections, and conversion campaigns lean on catalogue and search placements. We test every placement against your blended cost per acquisition and cut whatever does not earn its keep.'
    },
    {
        question: 'What reporting and analytics do you provide for ad campaign tracking?',
        answer: 'You get a live dashboard covering spend, CTR, CPA, ROAS and revenue by channel, plus a written weekly summary of what changed and why. Monthly, we walk you through the numbers, the creative learnings and the plan for the next 30 days.'
    },
    {
        question: 'Do you offer ongoing ad optimization and management services?',
        answer: 'Yes. Ongoing management is the core of what we do. Campaigns are monitored daily, budgets are reallocated to the best performers, creative is refreshed on a fixed cadence, and your strategy is revisited every quarter as your business grows.'
    }
]

export const servicePages = [
    {
        id: 'meta-ads',
        title: 'Meta Ads',
        body: 'Reach your ideal audience on Facebook and Instagram with our expertly managed Meta Ads campaigns. We focus on driving real results—whether it’s brand awareness, lead generation, or conversions—while optimizing your budget to get the most value from every dollar spent.',
        included: [
            'Comprehensive Audience Research & Targeting',
            'Ad Creation and Copywriting',
            'A/B Testing for Optimized Performance',
            'Ongoing Campaign Management and Monitoring',
            'Custom Budget Optimization Strategies',
            'Detailed Analytics and Reporting',
            'Retargeting Campaigns to Maximize Conversions',
            'Continuous Ad Creative Updates Based on Performance'
        ],
        investment: 'Packages start at $4,999 per month, covering full Meta Ads management, including strategy, ad creation, and optimization. Flexible options and custom plans are available to fit your unique needs. Contact us today for more details.',
        image: '/images/service-meta.jpg',
        alt: 'A laptop open on a tan leather sofa in warm afternoon light'
    },
    {
        id: 'google-ads',
        title: 'Google Ads',
        body: 'Dominate search results with expertly managed Google Ads campaigns. We help you reach high-intent customers exactly when they’re searching for your services. Our data-driven approach ensures your ads drive conversions while maximizing your budget’s efficiency.',
        included: [
            'Comprehensive Keyword Research & Targeting',
            'Custom Ad Copywriting and Design',
            'A/B Testing for Maximum Conversion',
            'Campaign Setup and Strategy Development',
            'Ongoing Campaign Monitoring and Management',
            'Budget Optimization to Maximize ROI',
            'Detailed Performance Reporting and Insights',
            'Retargeting Campaigns to Recapture Lost Leads'
        ],
        investment: 'Packages start at $6,999 per month, providing complete Google Ads management, including strategy development, ad creation, and ongoing optimization. Flexible payment options and customized plans are available to suit your business needs.',
        image: '/images/service-google.jpg',
        alt: 'A laptop resting on soft blush coloured bedding in morning light'
    },
    {
        id: 'tiktok-ads',
        title: 'TikTok Ads',
        body: 'Tap into the power of TikTok with creative ad campaigns that engage your audience. We help you craft viral-worthy ads that capture attention and drive action. Our team ensures every campaign is optimized for performance and designed to grow your brand on this fast-growing platform.',
        included: [
            'Target Audience Research & Precision Targeting',
            'Ad Creation with Engaging, Trend-Driven Content',
            'A/B Testing for Optimal Performance',
            'Full Campaign Management and Monitoring',
            'Budget Optimization for Maximum Impact',
            'Performance Analytics and Reporting',
            'Retargeting Strategies to Recapture Engaged Users',
            'Influencer Collaboration Strategy (Optional)'
        ],
        investment: 'Packages start at $3,999 per month, offering complete TikTok Ads management, from strategy and content creation to ongoing optimization. Customizable plans and flexible options are available to fit your goals and budget.',
        image: '/images/service-tiktok.jpg',
        alt: 'A smartphone on a pale surface cut across by hard window shadows'
    }
]

export const aboutProfessional = [
    {
        title: 'We’re certified experts in what we do',
        body: 'With years of experience, our team at Funnel is made up of certified professionals in digital marketing and web design. We stay up-to-date on the latest trends and best practices to ensure our clients get the most cutting-edge solutions.'
    },
    {
        title: 'Quality is our priority',
        body: 'We pride ourselves on delivering nothing short of excellence. Every project we take on is handled with meticulous attention to detail to ensure it not only looks great but performs exceptionally.'
    },
    {
        title: 'We’re results-driven',
        body: 'At Funnel, everything we do is focused on one thing—delivering measurable results. We create custom strategies designed to help our clients grow their business and achieve their goals.'
    }
]

export const aboutPersonal = [
    {
        title: 'We’re always laughing',
        body: 'Our office is filled with laughter—whether we’re cracking jokes during a brainstorming session or sharing funny stories from our weekends. We believe that having fun is key to staying creative and energized.'
    },
    {
        title: 'We’re a supportive bunch',
        body: 'We’re more than just colleagues—we’re a team that looks out for one another. Whether someone needs help on a project or just a pep talk, we’ve got each other’s backs.'
    },
    {
        title: 'We embrace quirkiness',
        body: 'We love that each team member brings something unique to the table, whether it’s a quirky hobby or an unusual talent. It’s what makes our team dynamic and keeps things interesting!'
    }
]
